const tooltipComponentByType = ['select'];

const getTooltipProps = (column) => {
  const tooltipTypeExist = tooltipComponentByType.includes(column.type);

  return tooltipTypeExist
    ? {
        tooltipField: column.field,
      }
    : {};
};

const getHeaderTooltipProps = ({ headerComponentParams }) =>
  headerComponentParams
    ? { headerComponentParams: { ...headerComponentParams, headerTooltip: true } }
    : { headerComponentParams: { headerTooltip: true } };

export const addTooltipPropsForColDefs = (columns) =>
  columns.map((column) => ({
    ...column,
    ...getTooltipProps(column),
  }));

export const addHeaderTooltipPropsForColDefs = (columns) =>
  columns.map((column) => ({
    ...column,
    ...getHeaderTooltipProps(column),
  }));
